import React from "react";
import { motion } from "framer-motion";
import { waveAnimation } from "../animate";

const Wave = () => {
  return (
    <svg viewBox="0 0 1920 317" fill="none" xmlns="http://www.w3.org/2000/svg">
      <motion.path
        d="M0 164.595C91.9337 61.8263 357.577 -95.0504 684.681 99.5962C1093.56 342.904 1326.45 353.445 1573.8 241.306C1771.68 151.596 1887.05 170.939 1920 191.825"
        stroke="#00FFD1"
        strokeOpacity="0.6"
        strokeWidth="15"
        variants={waveAnimation}
      />
    </svg>
  );
};

export default Wave;
